import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AllAppointmentsData } from 'src/app/_models/all-appointments.model';

@Component({
  selector: 'app-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.scss'],
})
export class AppointmentDetailsComponent implements OnInit {
  item: AllAppointmentsData;
  statusList = [
    { id: 1, state: 'Pending' },
    { id: 2, state: 'Finished' },
    { id: 3, state: 'Cancelled' },
    { id: 4, state: 'Not Completed' },
    { id: 5, state: 'History' },
    { id: 6, state: 'All' },
    { id: 7, state: 'Ready To Join' },
    { id: 8, state: 'Active' },
    { id: 9, state: 'Patient No Show'},
    { id: 10, state: 'Doctor No Show'},
    { id: 11, state: 'Received Passcode'}
  ];

  constructor(
    public bsModalRef: BsModalRef
  ) {}

  ngOnInit(): void {}

  getStatusName(id) {
    return (id) ? this.statusList.find((status) => status.id == id)?.state : '';
  }
}
